var render, staticRenderFns
import script from "./physicalCouponReceive.vue?vue&type=script&lang=js"
export * from "./physicalCouponReceive.vue?vue&type=script&lang=js"
import style0 from "./physicalCouponReceive.vue?vue&type=style&index=0&id=177d51cd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177d51cd",
  null
  
)

export default component.exports